import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    isDevMode,
    OnInit
} from '@angular/core';
import {Settings} from '@common/core/config/settings.service';
import {Translations} from '@common/core/translations/translations.service';
import {HomepageContent} from './homepage-content';
import {Router} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import { Unsub } from 'src/app/unsub.class';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingComponent extends Unsub implements OnInit {
    public content: HomepageContent;
    public overlayBackground;

    constructor(
        public settings: Settings,
        private i18n: Translations,
        private router: Router,
        private cd: ChangeDetectorRef,
        private sanitizer: DomSanitizer,
    ) {
        super();
    }

    ngOnInit() {
        this.settings.all$().pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
            this.content = this.settings.getJson('homepage.appearance');
            this.overlayBackground = this.sanitizer.bypassSecurityTrustStyle(
                `linear-gradient(45deg, ${this.content.headerOverlayColor1} 0%, ${this.content.headerOverlayColor2} 100%)`
            );
            this.cd.markForCheck();
        });
    }

    public scrollToFeatures() {
        document.querySelector('.first-secondary-feature')
            .scrollIntoView({block: 'center', inline: 'center', behavior: 'smooth'});
    }
    /**
     * Get absolute url for specified texture image.
     */
     public getTextureUrl(fileName: string): string {
        // return this.settings.getAssetUrl() + 'img/' + fileName;
        return isDevMode() ? `assets/img/${fileName}` : `client/assets/img/${fileName}`;
    }

    public copyrightText() {
        const year = (new Date()).getFullYear();
        return this.i18n.t('Copyright © :year, All Rights Reserved', {year});
    }
}
